import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import Input from 'react-toolbox/lib/input'
import { compose } from 'redux'
import { Tab } from 'react-toolbox/lib/tabs'
import { Flex } from 'reflexbox'
import CollapseButton from './CollapseButton'
import Collapse from 'components/fulcrum/collapse/Collapse'

import styles from './styles.scss'

class Content extends Component {
  static propTypes = {
    collapse: PropTypes.bool.isRequired,
    showContent: PropTypes.bool.isRequired,
    onCollapseButtonClick: PropTypes.func,
    onChange: PropTypes.func,
    input: PropTypes.string,
  }

  static defaultProps = {
    collapse: false,
    showContent: true,
  }

  render() {
    const {
      children,
      input,
      showContent,
      collapse,
      onCollapseButtonClick,
      onChange,
      label
    } = this.props

    return (
      <Collapse collapse={collapse}>
        <Flex flex column>
          <Input onChange={onChange} value={input} label={`Enter ${label} ...`} theme={styles} styleName='tabContentInput' />
          <Collapse theme={styles.animateHeightContainer} min={150} max='auto' collapse={showContent}>
            { children }
          </Collapse>
        </Flex>
        <CollapseButton
          collapse={showContent}
          onClick={onCollapseButtonClick}
        />
      </Collapse>
    )
  }
}
const withStyles = CSSModules(styles)
export default withStyles(Content)
